import(/* webpackMode: "eager", webpackExports: ["HomeContainer"] */ "/vercel/path0/apps/portals/src/app/[portalSlug]/(main)/container.tsx");
